<template>
    <v-container>
        <div>
            <template>
                <v-dialog v-model="dialog" transition="dialog-top-transition" max-width="500">
                    <template>
                        <v-card rounded="0">
                            <v-toolbar color="secondary" class="white--text">
                                <v-toolbar-title class="font-weight-bold">
                                    Warning
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon class="white--text" @click="closeModal">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </v-toolbar>
                            <v-card-text class="black--text pt-5 text-center" style="font-size: 20px">
                                <span>
                                    Are you sure ?
                                </span>
                            </v-card-text>
                            <v-card-text class="black--text text-center" style="font-size: 14px">
                                Do you really want to delete this record ?
                                <p class="mb-0">This process cannot be undone.</p>
                                
                            </v-card-text>
                            <div class="mx-4">
                                <v-divider ></v-divider>
                            </div>
                            <v-card-actions class="px-4 py-5 justify-center">
                                <div>
                                    <v-spacer></v-spacer>
                                    <v-btn @click="
                                        closeModal
                                    " outlined class="mr-2 px-5" right height="44" depressed color="primary" style="font-weight: 600;">
                                        Cancel
                                    </v-btn>
                                    <v-btn @click="deleteItem" right height="44" color="error" class="px-5" style="font-weight: 600;">
                                        Delete
                                    </v-btn>
                                </div>
                            </v-card-actions>
                        </v-card>
                    </template>
                </v-dialog>
            </template>
        </div>
    </v-container>
</template>
  
<script>


export default {
    computed: {
        dialog() {
            return this.dialogI
        },
    },
    methods: {
        closeModal() {
            this.$emit("closeDialog");
        },
        deleteItem() {
            this.$emit("delete")
        }
    },
    props: ["dialogI"],
};
</script>
  
<style scoped>

</style>
   